import { render, staticRenderFns } from "./OTPVerification.vue?vue&type=template&id=f25b99ca"
import script from "./OTPVerification.vue?vue&type=script&lang=js"
export * from "./OTPVerification.vue?vue&type=script&lang=js"
import style0 from "./OTPVerification.vue?vue&type=style&index=0&id=f25b99ca&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f25b99ca')) {
      api.createRecord('f25b99ca', component.options)
    } else {
      api.reload('f25b99ca', component.options)
    }
    module.hot.accept("./OTPVerification.vue?vue&type=template&id=f25b99ca", function () {
      api.rerender('f25b99ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/components/OTPVerification/OTPVerification.vue"
export default component.exports